<nav
  class="lk-eu-nav-bar"
  aria-label="Навигация личного кабинета">
  <div class="lk-eu-nav-bar__inner">
    <button
      type="button"
      class="lk-eu-nav-bar__burger lk-eu-nav-bar__burger--in-nav"
      [attr.aria-expanded]="mobileMenuOpen"
      aria-controls="lk-eu-nav-menu"
      (click)="toggleMobileMenu()">
      <i
        class="pi"
        [class.pi-bars]="!mobileMenuOpen"
        [class.pi-times]="mobileMenuOpen"
        aria-hidden="true"></i>
      <span>Меню</span>
    </button>

    <div
      id="lk-eu-nav-menu"
      class="lk-eu-nav-bar__menu"
      [class.lk-eu-nav-bar__menu--open]="mobileMenuOpen"
      role="tablist">
      @for (item of menuItems; track trackByLabel($index, item)) {
        @if (item.items?.length) {
          <div
            class="lk-eu-nav-dropdown"
            [class.lk-eu-nav-dropdown--open]="isDropdownOpen(item)"
            [class.lk-eu-nav-dropdown--active]="isTopItemActive(item)">
            <button
              type="button"
              class="lk-eu-nav-tab"
              [class.lk-eu-nav-tab--active]="isTopItemActive(item)"
              role="tab"
              [attr.aria-selected]="isTopItemActive(item)"
              [attr.aria-expanded]="isDropdownOpen(item)"
              (click)="toggleDropdown(item, $event)">
              <span class="lk-eu-nav-tab__caption">
                <span class="lk-eu-nav-tab__label">{{ item.label }}</span>
                @if (getActiveChildLabel(item); as childLabel) {
                  <span class="lk-eu-nav-tab__sublabel">{{ childLabel }}</span>
                }
              </span>
              <i
                class="pi pi-chevron-down lk-eu-nav-tab__chevron"
                aria-hidden="true"></i>
            </button>
            <div
              #dropdownPanel
              class="lk-eu-nav-dropdown__panel"
              role="menu">
              @for (child of item.items; track trackByLabel($index, child)) {
                @if (getItemHref(child); as href) {
                  <a
                    class="lk-eu-nav-dropdown__link"
                    [class.lk-eu-nav-dropdown__link--active]="isChildItemActive(child)"
                    [routerLink]="href"
                    role="menuitem"
                    (click)="onChildLinkClick()">
                    {{ child.label }}
                  </a>
                }
              }
            </div>
          </div>
        } @else {
          @if (getItemHref(item); as href) {
            <a
              class="lk-eu-nav-tab"
              [class.lk-eu-nav-tab--active]="isTopItemActive(item)"
              [routerLink]="href"
              role="tab"
              [attr.aria-selected]="isTopItemActive(item)"
              (click)="closeMobileMenu()">
              <span class="lk-eu-nav-tab__caption">
                <span class="lk-eu-nav-tab__label">{{ item.label }}</span>
              </span>
            </a>
          }
        }
      }
    </div>
  </div>
</nav>
